<template>
    <div>
        <div class="container">
            <div class="top-header-hold">
                <h3>Create Project</h3>
            </div>

            <div class="stepper-container">
                <!-- Progress Indicator Tracker -->
                <div class="progress-bar-wrapper">
                <!-- Background Line -->
                    <div class="connecting-line"></div>
                    <!-- Active Progress Filling Line -->
                    <div class="active-line" :style="{ width: activeLineWidth }"></div>

                    <!-- Steps Dots -->
                    <div 
                        v-for="step in 3" 
                        :key="step" 
                        class="step-dot"
                        :class="{ 'active': currentPage >= step }"
                    ></div>
                </div>
            </div>
            <!-- Page Content View Display -->
            

            <div class="form-card">
                <div class="" v-if="currentPage == 1">
                    <h4>Project Information</h4>

                    <div class="form">
                        <div class="form-group selected-option">
                            <label for="pn">Project name</label>
                            <input class="form-control" type="text" name="pn" id="pn" placeholder="Enter Project name">
                        </div>
                        <div class="form-group selected-option">
                            <label for="pt">Project type</label>
                           <select name="pt" id="pt" class="form-control">
                                <option value="">Select project type</option>
                                <option value="">Solar</option>

                           </select>
                        </div>
                        <div class="form-group selected-option">
                            <label for="ph">Do you want to add project handler</label>
                           <select name="ph" id="ph" class="form-control">
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                           </select>
                        </div>

                        <div class="form-group selected-option">
                            <label for="pd">Project details (optional)</label>
                           <textarea class="form-control" name="pd" id="pd" placeholder="enter details"></textarea>
                        </div>

                        <div class="form-group button-controls">
                            <button v-if="currentPage != 1" class="btn previous"@click="previousPage" 
                            :disabled="currentPage === 1">Previous</button>
                            <button class="btn next"@click="nextPage" 
                            :disabled="currentPage === 3">Next</button>
                        </div>
                    </div>
                </div>
                <div class="" v-if="currentPage == 2">
                    <h4>Project Funding</h4>

                    <div class="form">
                        <div class="form-group selected-option">
                            <label for="pa">Project amount</label>
                            <input class="form-control" type="text" name="pa" id="pa" placeholder="Enter Project amount">
                        </div>
                        <div class="form-group selected-option">
                            <label for="fq">Funding frequency</label>
                           <select name="fq" id="fq" class="form-control">
                                <option value="">Select</option>
                               

                           </select>
                        </div>
                        <div class="form-group selected-option">
                            <label for="phf">How would you like to fund this project?</label>
                           <select name="ph" id="ph" class="form-control">
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                           </select>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group selected-option">
                                    <label for="sd">Start date</label>
                                    <input type="date" class="form-control" name="sd" id="sd">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group selected-option">
                                    <label for="ed">End date</label>
                                    <input type="date" class="form-control" name="ed" id="ed">
                                </div>
                            </div>
                        </div>


                        <div class="form-group button-controls">
                            <button v-if="currentPage != 1" class="btn previous"@click="previousPage" 
                            :disabled="currentPage === 1">Previous</button>
                            <button class="btn next"@click="nextPage" 
                            :disabled="currentPage === 3">Next</button>
                        </div>
                       
                    </div>
                </div>

                <div v-if="currentPage == 3">
                    <h4>Project Summary</h4>

                    <div class="summary">
                        <div class="summary-item">
                            <p>Project Name</p>
                            <h5>Buy a house in Lagos</h5>
                        </div>
                        <hr>
                        <div class="summary-item">
                            <p>Project Type</p>
                            <h5>House purchase</h5>
                        </div>
                        <hr>
                        <div class="summary-item">
                            <p>Project Handler</p>
                            <h5>NO</h5>
                        </div>
                        <hr>
                        <div class="summary-item">
                            <p>Project Amount</p>
                            <h5>NO</h5>
                        </div>
                        <hr>
                        <div class="summary-item">
                            <p>Funding Frequency</p>
                            <h5>Monthly</h5>
                        </div>
                        <hr>
                        <div class="summary-item">
                            <p>Start Date</p>
                            <h5>25/05/2026</h5>
                        </div>
                        <hr>
                        <div class="summary-item">
                            <p>End Date</p>
                            <h5>25/05/2027</h5>
                        </div>
                    </div>
                    <div class="form-group button-controls">
                            <button v-if="currentPage != 1" class="btn previous"@click="previousPage" 
                            :disabled="currentPage === 1">Previous</button>
                            <button class="btn next" 
                            >Submit</button>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
// import $ from "jquery";
export default {
    name: "AddProject",
    components: {
        PageLoader,
    },

    data() {
        return {
            currentPage: 1, // State ranges from 1 to 3
            emptyDataObject: {
                header: "You haven't created any project yet",
                option: "Start by creating a project or join an available project that interests you."
            },
        };
    },
    computed: {
        // Calculates the percentage width for the active connector line overlay
        activeLineWidth() {
        if (this.currentPage === 1) return '0%';
        if (this.currentPage === 2) return '50%';
        return '100%';
        }
    },
    created() {
    },
    mounted() {

    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        nextPage() {
            if (this.currentPage < 3) this.currentPage++;
        },
        previousPage() {
            if (this.currentPage > 1) this.currentPage--;
        }
    }
};
</script>


<style scoped lang="scss">
.top-header-hold {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 22px;
        line-height: 26px;
        color: #1A1A1A;
        text-align: center;
    }
    
}

.stepper-container {
  width: 100%;
  max-width: 400px;
  margin: 20px auto;
  font-family: sans-serif;
}

/* Progress bar container structure */
.progress-bar-wrapper {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  width: 100%;
  height: 15px; /* Aligns container height with dot size */
}

/* Static gray background bridge connecting line */
.connecting-line {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;
  height: 3px;
  background-color: #e0e0e0;
  z-index: 1;
}

/* Dynamic purple filling indicator active tracking line */
.active-line {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  height: 3px;
  background-color: #0033EA; /* Church app theme purple */
  transition: width 0.3s ease;
  z-index: 2;
}

/* Exact 15px circular indicator dots */
.step-dot {
  width: 15px;
  height: 15px;
  background-color: #e0e0e0;
  border-radius: 50%;
  position: relative;
  z-index: 3;
  transition: background-color 0.3s ease;
}

/* Active status indicator dot styling override */
.step-dot.active {
  background-color: #0033EA;;
}

/* Layout for content preview window */
.page-content {
  text-align: center;
  padding: 40px 20px;
  background: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 20px;
}

/* Flex layout spacing configuration for footer buttons */
.navigation-controls {
  display: flex;
  justify-content: space-between;
}

.nav-btn {
  padding: 10px 20px;
  border: none;
  background-color: #cccccc;
  color: #333;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.next-btn {
  background-color: #0033EA;
  color: white;
}

.form-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 24px;
    max-width: 700px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    margin: auto;
    h4 {
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 26px;
        color: #1A1A1A;
        text-align: center;
        margin-bottom: 30px;
    }
}
.form-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.12);
}

.selected-option {
    label {
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        line-height: 26px;
        color: #1A1A1A;
        text-align: left;
        display: flex;

    }
    input, select {
        padding: 10px;
        border: 1px solid #E6E9EC;
        cursor: pointer;
        // display: flex;
        // align-items: center;
        // gap: 10px;
        background: #fff;
        border-radius: 4px;
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        box-shadow: none;
        outline: 0;
        height: 45px;
    }
}

.button-controls {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    margin-top: 30px;
    gap: 10px;
    .next {
        background: #0033EA;
        color: #ffffff;
        font-family: Lato;
        font-weight: 500;
        font-size: 18px;
        min-height: 58px;
        width: 100%;
        box-shadow: none;
        outline: 0;
    }
    .previous {
        background: #ffffff;
        color: #0033EA;
        border: 1px solid #0033EA;
        font-family: Lato;
        font-weight: 500;
        font-size: 18px;
        min-height: 58px;
        width: 100%;
        box-shadow: none;
        outline: 0;
    }
}

.summary-item {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #555555;
        text-align: left;
        margin-bottom: 0;
    }
    h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #1A1A1A;
        text-align: right;
        margin-bottom: 0;
    }
}
</style>